/**
 * CSCOIVA-3016 – Builder for the change object that represents a pre-selected
 * vaativaTuki radio button for a new (empty) permit.
 *
 * @param {string} koodiarvo  - koodiarvo of the radio button to pre-select,
 *                              e.g. "2"
 * @param {string} koodisto   - koodisto name of the item
 * @param {string} sectionId  - the section anchor prefix, e.g. "muut_02"
 * @returns {Object} A change object compatible with the muutokset store.
 */
export function buildDefaultVaativaTukiChangeObject(
  koodiarvo,
  koodisto,
  sectionId = "muut_02"
) {
  return {
    anchor: `${sectionId}.vaativatuki.${koodiarvo}.A`,
    properties: {
      isChecked: true,
      metadata: {
        koodiarvo,
        koodisto: {
          koodistoUri: koodisto
        }
      }
    }
  };
}

/** koodiarvo values that count as an existing vaativaTuki määräys */
export const VAATIVA_TUKI_KOODIARVOT = ["2", "16", "17", "18", "19", "20", "21"];

/**
 * CSCOIVA-3016 – Pure helper used by WizardContainer's useEffect.
 *
 * Decides whether the default vaativaTuki change object ("25") should be
 * injected and, if so, merges it into a copy of `changeObjectsFromBackend`.
 *
 * @param {object|null|undefined} muutospyynto          – the existing muutospyynto (null/undefined = new permit)
 * @param {object|null|undefined} viimeisinLupa         – the last valid lupa object
 * @param {Record<string,*>}      changeObjectsFromBackend – already-parsed change objects
 * @returns {Record<string,*>} A (possibly mutated copy of) changeObjectsFromBackend.
 */
export function injectDefaultVaativaTukiIfNeeded(
  muutospyynto,
  viimeisinLupa,
  changeObjectsFromBackend
) {
  const isNewPermit = !muutospyynto;

  const hasExistingVaativaTukiMaarays = viimeisinLupa?.maaraykset?.some(
    m =>
      m.koodisto === "oivamuutoikeudetvelvollisuudetehdotjatehtavat" &&
      VAATIVA_TUKI_KOODIARVOT.includes(m.koodiarvo)
  );

  if (!isNewPermit || hasExistingVaativaTukiMaarays) {
    return changeObjectsFromBackend;
  }

  const defaultCO = buildDefaultVaativaTukiChangeObject(
    "25",
    "oivamuutoikeudetvelvollisuudetehdotjatehtavat"
  );

  const result = { ...changeObjectsFromBackend };

  if (!result.muut) {
    result.muut = { "02": [defaultCO] };
  } else {
    result.muut = {
      ...result.muut,
      "02": [...(result.muut["02"] || []), defaultCO]
    };
  }

  return result;
}

